module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/cross-3fd20ce1e8df692bf40dcc74de9a8e2f.svg";